import { api } from './api';
import type {
  BridgeFees,
  BridgeInfo,
  PendingBatch,
  PendingSendsResponse,
  PendingDepositsResponse,
} from '@/types/bridge';

/**
 * Bridge API service for Gravity Bridge ↔ Ethereum transfers
 */
export const bridgeService = {
  /**
   * Get bridge fees for a given amount
   * @param amountUgraviton Amount in ugraviton to calculate fees for
   */
  async getBridgeFees(amountUgraviton?: string): Promise<BridgeFees> {
    const params = (amountUgraviton !== undefined && amountUgraviton !== '') ? { amount: amountUgraviton } : {};
    return api.get<BridgeFees>('/bridge/fees', params);
  },

  /**
   * Get pending sends for a Gravity address (Gravity → ETH)
   * @param address Gravity Bridge address (gravity1...)
   */
  async getPendingSends(address: string): Promise<PendingSendsResponse> {
    return api.get<PendingSendsResponse>(`/bridge/pending-sends/${address}`);
  },

  /**
   * Get pending deposits for an address (ETH → Gravity)
   * @param address Gravity Bridge address (gravity1...)
   */
  async getPendingDeposits(address: string): Promise<PendingDepositsResponse> {
    return api.get<PendingDepositsResponse>(`/bridge/pending-deposits/${address}`);
  },

  /**
   * Get global pending batches
   */
  async getPendingBatches(): Promise<PendingBatch[]> {
    return api.get<PendingBatch[]>('/bridge/pending-batches');
  },

  /**
   * Get bridge info (contract address, fee rate, etc.)
   */
  async getBridgeInfo(): Promise<BridgeInfo> {
    return api.get<BridgeInfo>('/bridge/info');
  },
};
